/** Default landing URL for a role after login / portal switch / logo click.
 * Analytics lands on its executive dashboard (`/analytics`); all other roles
 * use the legacy `/{role}_order_list/index` order-list path. */
export function getPortalLandingPath(role: string): string {
  return role === "analytics" ? "/analytics" : `/${role}_order_list/index`;
}

/** Provider login page that returns to `redirectTo` after login. */
export function getProviderLoginUrl(redirectTo: string): string {
  return `/password-login?type=provider&redirect_to=${encodeURIComponent(redirectTo)}`;
}
